import { render, staticRenderFns } from "./mailingList.vue?vue&type=template&id=078ebf94&scoped=true&"
import script from "./mailingList.vue?vue&type=script&lang=js&"
export * from "./mailingList.vue?vue&type=script&lang=js&"
import style0 from "./mailingList.vue?vue&type=style&index=0&id=078ebf94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078ebf94",
  null
  
)

export default component.exports